import React, { useState, useEffect } from "react";
import Styles from "./BannerDest.module.scss";
import classnames from "classnames";
import A from "@vahak/core/dist/components/app-anchor/A";
import ArrowDownWhite from "@vahak/core/dist/icons/arrowDownWhite.svg";
import AppImg from "components/utils/AppImg";
import { getTransporterFigure } from "@vahak/core/dist/methods/getTransporterFigure";

const BannerDest = () => {
    const [state, setState] = useState(0);

    const scrollToSection = () => {
        const viewPortWidth = window.screen.availWidth;
        window.scroll({
            top: viewPortWidth,
            behavior: "smooth"
        });
    };

    useEffect(() => {
        window?.addEventListener("scroll", function () {
            const viewPortWidth = window.screen.availWidth;
            const scrollY = window.scrollY;
            if (viewPortWidth >= 1200) {
                setState(scrollY + 560);
            } else if (viewPortWidth >= 1300) {
                setState(scrollY + 640);
            } else if (viewPortWidth >= 1400) {
                setState(scrollY + 700);
            } else {
                setState(scrollY + 480);
            }
        });
    }, []);

    return (
        <section
            className={classnames(Styles.bannerSection, "flipAnimate")}
            style={{ paddingLeft: state >= 1000 ? "-4%" : "0" }}
        >
            <div className={`${state >= 1000 ? "" : "container"}`} style={{ height: "100%" }}>
                <div className={Styles.bannerRow}>
                    <div className={Styles.textCol}>
                        <div className={Styles.text}>
                            <h1>
                                Building India’s Leading{" "}
                                <span data-hover="B2B Road Transportation Marketplace" className="indaiText">
                                    B2B Road Transportation Marketplace
                                </span>
                            </h1>
                            <A
                                className={Styles.meetUsBtn}
                                onClick={scrollToSection}
                                style={{
                                    backgroundColor: "#1053FF",
                                    color: "#fff",
                                    textAlign: "center",
                                    fontSize: "20px",
                                    padding: "15px",
                                    height: "60px",
                                    width: "190px",
                                    display: "block",
                                    marginTop: "40px",
                                    lineHeight: "32px",
                                    fontWeight: "bold",
                                    borderRadius: "6px"
                                }}
                            >
                                <span>
                                    Meet Us{" "}
                                    <ArrowDownWhite
                                        style={{
                                            width: "15px",
                                            height: "15px",
                                            position: "relative",
                                            top: "-1px",
                                            right: "-7px",
                                            transform: "rotate(90deg)"
                                        }}
                                    />
                                </span>
                            </A>
                        </div>
                    </div>
                </div>

                <div
                    className={Styles.aboutStoryCol}
                    style={{
                        width: state,
                        top: state >= 1000 ? "70px" : "100px"
                    }}
                >
                    <div className={Styles.storyImgWrap}>
                        <div
                            style={{
                                position: "relative",
                                borderRadius: state >= 1000 ? "0px" : "15px",
                                overflow: state >= 900 ? "hidden" : undefined,
                                // overflow: "hidden",
                                marginLeft: state >= 900 ? "-10px" : undefined,
                                filter: state >= 900 ? "blur(30px)" : undefined,
                                height: state >= 1000 ? "87vh" : "75vh",
                                translate: "height 2000",
                                width: "100%"
                            }}
                        >
                            <AppImg
                                className={classnames(Styles.imgBgBox, "rounder-full")}
                                src={`KaranVikasDesktop.jpg`}
                                quality={100}
                                alt={"our story"}
                                layout="fill"
                                width="700"
                                height="568"
                                priority
                            />
                        </div>

                        {state >= 1000 && (
                            <div className={Styles.ourStory}>
                                <div className="container">
                                    <div className={Styles.ourStoryText}>
                                        <h2>Our Story</h2>
                                        <p>
                                            &quot;The story begins with Karan, one of our co-founders, noticing a huge
                                            problem in India’s logistics space – SMEs were struggling to transport their
                                            product! To resolve this problem and provide logistics companies with the
                                            kind of support they needed to flourish, Karan joined with Vikas, our
                                            second-cofounder, to create Epictus Solutions. This venture helped logistics
                                            businesses with GPS and transportation solutions. With Epictus’ rapid
                                            growth, the co-founders came to a realization that Indian transporters
                                            needed more than what their venture offered – they needed an extensive
                                            platform that would let them digitize all their day-to-day business
                                            operations!
                                        </p>
                                        <p>
                                            And so, after trials, errors and lots of learning – Vahak was born. Today,
                                            Vahak is the largest online transport marketplace community with over{" "}
                                            {getTransporterFigure()} Indian transporters on it&apos;s platform. In the
                                            Indian logistics space, we aim to be more than just a product – we want to
                                            revolutionize the way B2B transportation happens in India!
                                        </p>
                                        <p>
                                            With the Vahak app, users should no longer struggle to get or provide
                                            logistics services. Logistics is the backbone of the Indian economy, and
                                            we&apos;re here to strengthen it! By providing users with the technology for
                                            booking trucks and loads online, we&apos;re bridging the gap between lorry
                                            and load businesses, and helping them serve customers better.&quot;
                                        </p>
                                    </div>
                                </div>
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </section>
    );
};

export default BannerDest;
